<template>
    <div>
        <div v-if="playlists.length==0" class="product-empty">
            <div>
                <img class="image-empty" src="/image/icons/state_playlist_emp.png" alt="empty">
            </div>
            <div class="message">{{ characters.not_exist_playlist }}</div>
            <!-- <div><button class="button btn btn-dark" role="button" aria-pressed="true" @click="openModal()">プレイリストを新規作成する</button></div> -->
            <!-- <div class="confirm"><button type="submit" id="open">プレイリストを新規作成する</button></div> -->

        </div>
        <div v-else class="product-item screen-transition" v-for="playlist in playlists" @click="playlist_click(playlist.playlist_id)">
            <div class="playlist-info">
                <div class="playlist-title">{{ playlist.title }}</div>
                <div class="playlist-count">{{ playlist.count }}{{ characters.number_of_music }}</div>
            </div>
            <div class="item-price-container">
                <img src="/image/icons/next.png">
            </div>
        </div>

        <div style="margin: 1em">
            <div><button class="create-button" role="button" aria-pressed="true" @click="openModal()">{{ characters.regist_playlist }}</button></div>
            <!-- <div class="confirm"><button type="submit" id="open">プレイリストを新規作成する</button></div> -->
        </div>

        <div v-show="showContent">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper" @click.self="closeModal()">
                        <div class="modal-container">
                            <div class="modal_ln">
                                <p id="regist_playlist">{{ characters.regist_playlist }}</p>
                                <input type="text" v-model="title" id="title" :placeholder="characters.input_playlist_name">
                            </div>
                            <div class="modal_btn">
                                <button id="close" @click="closeModal()">{{ characters.cancel }}</button>
                                <button id="make" @click="makePlaylist()">{{ characters.create }}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div id="modal">
                    <p>{{ characters.regist_playlist }}</p>
                    <div class="modal_ln">
                        <input type="text" id="title" v-model="title" :placeholder="characters.input_playlist_name">
                    </div>
                    <div class="modal_btn">
                        <button id="close" @click="closeModal()">{{ characters.cancel }}</button>
                        <button if="make" @click="makePlaylist()">{{ characters.create }}</button>
                    </div>
                </div> -->
            </transition>
        </div>

    </div>
</template>

<script>
    export default {
        name: "add-playlist",
        props: ['music_id', 'json_characters'],
        data: function () {
            return {
                showContent: false,
                playlists: [],
                title: '',
                characters: Object,
            }
        },
        mounted() {
            axios.default
                .post('/purchased_list/playlist')
                .then(response => {
                    console.log(response.data);
                    this.playlists = response.data;
                });
            this.characters = JSON.parse(this.json_characters);
        },
        methods: {
            playlist_click: function (id) {
                // console.log('playlist', id);
                location.href = '/playlist/add/' + id + '/' + this.music_id;
            },
            openModal: function() {
                this.showContent=true;
            },
            closeModal: function() {
                this.showContent=false;
            },
            makePlaylist: function() {
                if(this.title === '') {
                    alert(this.characters.input_playlist_name);
                } else {
                    axios.default
                        .post('/playlist/make/' + this.title)
                        .then(response => {
                            console.log(response.data);
                            let playlist_id = response.data;
                            location.href = '/playlist/add/' + playlist_id + '/' + this.music_id;
                        });
                }
            }
        },
    }
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
  /* max-width: 400px; */
  /* -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -ms-box-sizing: border-box;
  -o-box-sizing: border-box;
  box-sizing: border-box; */
  /* padding: 0px; */
  /* -webkit-border-radius: .8em;
  -moz-border-radius: .8em;
  border-radius: .8em; */
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

 .modal-container {
  width: 70%;
  max-width: 300px;
  margin: 0px auto;
  padding: 5px 0px 0px 0px;
  background-color: #fff;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -ms-box-sizing: border-box;
  -o-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-border-radius: .8em;
  -moz-border-radius: .8em;
  border-radius: .8em;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}


/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */


.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.create-button {
	margin: 0 auto;
	text-align: center;
    position: relative;
    display: inline-block;
    width: 60%;
    letter-spacing: .1em;
    line-height: 3rem;
    color: #fff;
    background: #161616;
	-webkit-border-radius: 2.5em;
	-moz-border-radius: 2.5em;
	border-radius: 2.5em;
	border: none;
	box-shadow: none;
}

#overlay {
    display: none;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 9;
    background-color: rgba(0, 0, 0, .50);
}

#modal {
    /* display: none; */
    position: fixed;
    left: 50%;
    top: 50%;
    z-index: 99;
    transform: translate(-50%, -50%);
    width: 70%;
    max-width: 400px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -ms-box-sizing: border-box;
    -o-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0px;
    -webkit-border-radius: .8em;
    -moz-border-radius: .8em;
    border-radius: .8em;
    background-color: #fff;
}

#regist_playlist {
    text-align: center;
    margin: 20px 0 20px;
    font-size: 1rem;
}

.active {
    display: block !important;
}

.modal_ln {
    text-align: center;
    margin: 0 0 20px;
}

.modal_ln input[ type=text ] {
    width: 90%;
    font-size: 0.8rem;
}

.modal_btn {
	margin: 0;
    padding: 0;
	text-align: center;
    border-top: 1px solid gray;
}
.modal_btn button[ id=close ]{
    position: relative;
    display: inline-block;
    width: 45%;
    line-height: 3rem;
    color: dodgerblue;
    background: #FFF;
	-webkit-border-radius: 0 0 0 .8em;
	-moz-border-radius: 0 0 0 .8em;
	border-radius: 0 0 0 .8em;
	border: none;
	box-shadow: none;
    border-right: 1px solid gray;
    font-size: 0.8rem;
}
.modal_btn button[ id="make" ]{
    position: relative;
    display: inline-block;
    width: 45%;
    line-height: 3rem;
    color: dodgerblue;
    background: #FFF;
	-webkit-border-radius: 0 0 .8em 0;
	-moz-border-radius: 0 0 .8em 0;
	border-radius: 0 0 .8em 0;
	border: none;
	box-shadow: none;
    font-size: 0.8rem;
}

</style>
